import { NgModule } from "@angular/core";
import { PreloadAllModules, RouterModule, Routes } from "@angular/router";
import { ViewAllPaymentLinkPage } from "./pages/view-all-payment-link/view-all-payment-link.page";
import { ViewAllRedeemptionPage } from "./pages/view-all-redeemption/view-all-redeemption.page";
import { WayyakTransactionPage } from "./pages/wayyak-transaction/wayyak-transaction.page";

const routes: Routes = [
  { path: "", redirectTo: "front", pathMatch: "full" },
  {
    path: "home",
    loadChildren: () =>
      import("./pages/home/home.module").then((m) => m.HomePageModule),
  },
  {
    path: "popup",
    loadChildren: () =>
      import("./pages/popup/popup.module").then((m) => m.PopupPageModule),
  },
  {
    path: "transactions",
    loadChildren: () =>
      import("./pages/transactions/transactions.module").then(
        (m) => m.TransactionsPageModule
      ),
  },
  {
    path: "login",
    loadChildren: () =>
      import("./pages/login/login.module").then((m) => m.LoginPageModule),
  },
  {
    path: "all-transaction",
    loadChildren: () =>
      import("./pages/all-transaction/all-transaction.module").then(
        (m) => m.AllTransactionPageModule
      ),
  },
  {
    path: "front",
    loadChildren: () =>
      import("./pages/front/front.module").then((m) => m.FrontPageModule),
  },
  {
    path: "menu",
    loadChildren: () =>
      import("./pages/menu/menu.module").then((m) => m.MenuPageModule),
  },
  {
    path: "set-password",
    loadChildren: () =>
      import("./pages/set-password/set-password.module").then(
        (m) => m.SetPasswordPageModule
      ),
  },
  {
    path: "full-info",
    loadChildren: () =>
      import("./pages/full-info/full-info.module").then(
        (m) => m.FullInfoPageModule
      ),
  },
  {
    path: "payment-link",
    loadChildren: () =>
      import("./pages/payment-link/payment-link.module").then(
        (m) => m.PaymentLinkPageModule
      ),
  },
  {
    path: "upload-status",
    loadChildren: () =>
      import("./pages/upload-status/upload-status.module").then(
        (m) => m.UploadStatusPageModule
      ),
  },
  {
    path: "wayyak-transaction",
    component: WayyakTransactionPage,
  },
  {
    path: "veiw-all-payment-link",
    component: ViewAllPaymentLinkPage,
  },
  {
    path: "veiw-all-redeemption",
    component: ViewAllRedeemptionPage,
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
